// extracted by mini-css-extract-plugin
module.exports = {"SearchInput":"SearchInput__SearchInput__2i4jy","icon":"SearchInput__icon__3Hj4h"};